import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FrameComponent } from './frame.component';
import { HeaderComponent } from '../../components/header/header.component';
import { RouterModule } from '@angular/router';
import { Menubar } from 'primeng/menubar';
import { MenuModule } from 'primeng/menu';
import { FooterComponent } from '../../components/footer/footer.component';
import { DrawerFrameModule } from '../../components/drawer-frame/drawer-frame.module';
import { ChangePasswordDrawerModule } from '../../components/drawers/change-password-drawer/change-password-drawer.module';
import { FormModule } from '../../modules/form/form.module';
import { SharedModule } from '../../modules/shared/shared.module';
@NgModule({
  declarations: [
    FrameComponent,
    HeaderComponent,
    FooterComponent,
  ],
  imports: [
    CommonModule,
    RouterModule,
    Menubar,
    MenuModule,
    DrawerFrameModule,
    ChangePasswordDrawerModule,
    FormModule,
    SharedModule,
  ]
})
export class FrameModule { }
